"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import XmarkIcon from "@infinitaslearning/pixel-icons/Xmark";
import { alertClasses, buttonClasses } from "@mui/material";
import InnerAlert from "@mui/material/Alert";
import { styled } from "@mui/material/styles";
import { useCheckThemeContext } from "../../hooks/useCheckThemeContext";
import { IconButton } from "../IconButton/IconButton.styled";
import { filledStyles, outlinedStyles, standardStyles } from "./Alert.theme";
const StyledAlert = styled(InnerAlert, {
    shouldForwardProp: (prop) => !["pxlSeverity"].includes(prop.toString()),
})(({ theme, pxlSeverity }) => {
    const dt = theme.pixel;
    return Object.assign({}, (pxlSeverity === "neutral" && {
        borderColor: dt.color.outlineVariant,
        backgroundColor: dt.color.surface.variant,
        [`.${alertClasses.icon} .PixelIcon`]: {
            backgroundColor: dt.color.onSurface.variant,
        },
        [`.${alertClasses.message}`]: {
            color: dt.color.onSurface.key,
        },
        [`.${buttonClasses.text}`]: {
            color: dt.cta.outlined.color.text.primary.default,
        },
        [`&.${alertClasses.standard}`]: Object.assign(Object.assign({}, standardStyles(dt, ["neutral"])), { ".PixelIcon": {
                backgroundColor: dt.color.onSurface.variant,
            } }),
        [`&.${alertClasses.outlined}`]: Object.assign(Object.assign({}, outlinedStyles(dt, ["neutral"])), { borderStyle: "solid", backgroundColor: "transparent", ".PixelIcon": {
                backgroundColor: dt.color.onSurface.variant,
            } }),
        [`&.${alertClasses.filled}`]: Object.assign(Object.assign({}, filledStyles(dt, ["neutral"])), { backgroundColor: dt.color.onSurface.variant, [`.${alertClasses.message}`]: {
                color: dt.color.onPrimary.key,
                maxWidth: "640px",
            } }),
    }));
});
export const Alert = React.forwardRef((_a, ref) => {
    var _b;
    var { children } = _a, props = __rest(_a, ["children"]);
    useCheckThemeContext("Alert");
    const getSeverity = (obj) => {
        if (obj.pxlSeverity) {
            if (obj.pxlSeverity !== "neutral") {
                return obj.pxlSeverity;
            }
        }
        if (obj.severity) {
            return obj.severity;
        }
        return undefined;
    };
    const closeButtonProp = props.variant === "filled" ? "inverted" : undefined;
    return (_jsx(StyledAlert, Object.assign({}, props, { "data-pixel": "Alert", ref: ref, severity: getSeverity(props), slots: {
            closeButton: IconButton,
            closeIcon: XmarkIcon,
        }, slotProps: Object.assign(Object.assign({}, props.slotProps), { closeButton: Object.assign(Object.assign({}, (_b = props.slotProps) === null || _b === void 0 ? void 0 : _b.closeButton), { color: closeButtonProp }) }), children: children })));
});
